import React, { Component } from "react";
import $ from "jquery";
import OwlCarousel from "react-owl-carousel2";
// import "react-owl-carousel2/src/owl.theme.default.css";
// import "react-owl-carousel2/src/owl.carousel.css";
import "react-owl-carousel2/lib/styles.css";
import { ReactComponent as Back } from "../../assets/svg/back.svg";
import { ReactComponent as WhiteBack } from "../../assets/svg/whiteBack.svg";
import { ReactComponent as ArrowLeft } from "../../assets/svg/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../assets/svg/arrow-right.svg";
import PropTypes from "prop-types";
import { ReactComponent as LeftArrow } from "../../assets/svg/leftarrowprofile.svg";

let actionRecognizer = 0;
class GenericCarousel extends Component {
  constructor(props) {
    super(props);
    this.ref = "";
    this.state = { activeItemIndex: 0 ,activeDotIndex:0};
    //In case children provided to GenericCarousel is React Component
    this.madeUpChildren =
      props.hasOwnProperty("numberOfChildren") &&
      new Array(props.numberOfChildren).fill("");
    window.jQuery = $;
    window.$ = $;
  }
  static propTypes = {
    /**This prop is required if children passed to generic Carousel is a React Component */
    numberOfCards: PropTypes.number
  };

  indexChangeHandler = arrowActionTo => {
    if (this.props.toChangeBgColor == undefined) {
      // this.props.onActiveIndexChange(arrowActionTo,this.props.children)
      // }else{
      const { activeItemIndex } = this.state;
      const { children } = this.props;
      setTimeout(() => {
        if (
          arrowActionTo === "right" &&
          children.length - 1 > activeItemIndex
        ) {
          this.setState({ activeItemIndex: activeItemIndex + 1 });
        } else if (arrowActionTo === "left" && activeItemIndex > 0) {
          this.setState({ activeItemIndex: activeItemIndex - 1 });
        }
      }, 200);
    }
  };

  renderFooterDots = () => {
    const {
      toChangeBgColor,
      numberOfChildren,
      activeIndexAside,
      children
    } = this.props;
    const childrenDots = numberOfChildren ? this.madeUpChildren : children;
    if (toChangeBgColor !== undefined || numberOfChildren !== undefined) {
      return (
        <div id="dot-parent-aside">
          {childrenDots.length &&
            childrenDots.map((element, index) => {
              return (
                <div
                  onClick={() => {
                    this.props.onActiveIndexChange(index);
                    if (index == actionRecognizer + 1) {
                      this.refs.car.next();
                      actionRecognizer = index;
                    } else if (index == actionRecognizer - 1) {
                      this.refs.car.prev();
                      actionRecognizer = index;
                    } else {
                      this.refs.car.goTo(index);
                    }
                    actionRecognizer = index;
                  }}
                  style={{
                    background:
                      index == activeIndexAside ? "#fff" : "transparent",
                    cursor: "pointer"
                  }}
                  className="dot"
                  key={index}
                >
                  .
                </div>
              );
            })}
        </div>
      );
    }
  };

  render() {
    const { toChangeBgColor, numberOfChildren} = this.props;
    const options = {
      items: this.props.numberOfCards,
      nav: false,
      autoplay:
        this.props.autoPlay !== undefined && this.props.autoPlay ? true : false,
      Default: 1,
      autoWidth: false,
      margin: this.props.marginLeft,
      dots: this.props.dots,
      rewind:
        this.props.autoPlay !== undefined && this.props.autoPlay ? true : false,
      slideBy: 5
      // autoplay:this.props.autoPlay?this.props.autoPlay:false
      // mouseDrag:false,
    };

    const events = {
      onDragged: event => {
        (toChangeBgColor !== undefined || numberOfChildren !== undefined) &&
          this.props.onActiveIndexChange(event.item.index);
      },
      onChanged: event => {
        (toChangeBgColor !== undefined || numberOfChildren !== undefined) &&
          this.props.onActiveIndexChange(event.item.index);
      }
    };

    return (
      <React.Fragment>
        <OwlCarousel events={events} ref="car" options={options}>
          {this.props.children}
        </OwlCarousel>
        {((this.props.fromLandingPage !== undefined &&
          this.props.fromLandingPage &&
          !(this.props.hasOwnProperty("isMobile") && this.props.isMobile)) ||
          (this.props.fromCourseDescription !== undefined &&
            this.props.fromCourseDescription)) && (
          <div
            id={
              this.props.fromLandingPage !== undefined &&
              this.props.fromLandingPage
                ? "parent-div-arrows"
                : "carousel-separate-arrows"
            }
            className={
              this.props.fromCourseDescription && !this.props.fromUserProgram
                ? "center-arrow"
                : this.props.fromLandingPage
                ? "top-arrow"
                : this.props.fromUserProgram
                ? "user-prog-arrow"
                : ""
            }
          >
            <div onClick={() => this.refs.car.prev()} className="left">
              <LeftArrow />
            </div>
            <div onClick={() => this.refs.car.next()} className="right">
              <LeftArrow />
            </div>
          </div>
        )}

        {((this.props.fromAboutUsPage !== undefined &&
          this.props.fromAboutUsPage) ||
          this.props.fromAboutUsPageJourney !== undefined) && (
          <div
            id={
              this.props.fromAboutUsPage !== undefined &&
              this.props.fromAboutUsPage
                ? "parent-div-arrows"
                : "parent-div-white-arrows"
            }
          >
            <div
              onClick={() => {
                this.indexChangeHandler("left");
                this.refs.car.prev();
              }}
              className="left"
            >
              {this.props.fromAboutUsPage !== undefined ? (
                <Back />
              ) : this.props.fromAboutUsPageJourney != undefined ? (
                <WhiteBack />
              ) : null}
            </div>
            {this.props.fromAboutUsPageJourney == undefined && (
              <React.Fragment>
                {this.props.children.map((element, index) => {
                  return (
                    <div
                      style={{
                        marginRight: "6px",
                        color: "transparent",
                        background:
                          this.state.activeItemIndex == index
                            ? "#4c26ff"
                            : "#c1c3cc"
                      }}
                      className="card-dot"
                      key={index}
                    >
                    </div>
                  );
                })}
              </React.Fragment>
            )}
            <div
              onClick={() => {
                this.indexChangeHandler("right");
                this.refs.car.next();
              }}
              className="right"
            >
              {this.props.fromAboutUsPage !== undefined ? (
                <Back />
              ) : this.props.fromAboutUsPageJourney != undefined ? (
                <WhiteBack />
              ) : null}
            </div>
          </div>
        )}

        {/* {this.renderFooterDots()}  */}

        {this.props.hasOwnProperty("fromCollegeLanding") && (
          <div className="side-carousel-arrows">
            <div
              onClick={() => this.refs.car.prev()}
              className={`left ${this.props.shiftArrow ? "shift-arrow" : ""}`}
            >
              <ArrowLeft />
            </div>
            <div
              onClick={() => this.refs.car.next()}
              className={`right ${this.props.shiftArrow ? "shift-arrow" : ""}`}
            >
              <ArrowRight />
            </div>
          </div>
        )}
        {this.props.fromDmPage && (
          <div id={"parent-div-arrows"}>
            <React.Fragment>
              {this.props.children.map((element, index) => {
                return (
                  <div
                    style={{
                      marginRight: "6px",
                      color: "transparent",
                      background:
                        this.state.activeDotIndex == index
                          ? "#4c26ff"
                          : "#c1c3cc"
                    }}
                    className="card-dot"
                    key={index}
                    onClick={() => {
                      this.setState({
                        activeDotIndex :index
                      },()=>{
                        this.refs.car.goTo(index);
                      })
                    }}
                  >
                  </div>
                );
              })}
            </React.Fragment>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default GenericCarousel;
